<template>
  <div id="app">
    <notifications group="app" position="bottom right" />
    <notifications group="undo" position="bottom right" :duration="10000">
      <template slot="body" slot-scope="props">
        <div class="vue-notification">
          <span>{{ props.item.text }}</span>
          <button
            data-cy="undo-toast-action"
            class="btn btn-link btn-sm text-white p-0 ml-2"
            @click="
              props.item.data.onUndo();
              props.close();
            "
          >
            Undo
          </button>
        </div>
      </template>
    </notifications>
    <files-preview />
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import metaMixin from '@/mixins/metaMixin';
import store from './store/index';
import FilesPreview from './components/FilesPreview';
import { checkVersion } from './utils/checkVersion';
import { needToCheckVersion } from './router.rules';

export default {
  name: 'app',
  mixins: [metaMixin],
  components: {
    FilesPreview
  },
  async created() {
    if (store.getters.isAuthenticated) {
      if (!needToCheckVersion.find((e) => location.pathname?.match(e))) {
        checkVersion();
      }
    }
  }
};
</script>
